import { Input } from "antd";
import PropTypes from "prop-types";

import classnames from "classnames";
import Label from "../../Label";

const stripPhoneValue = (value, maxLength) => {
  let cleaned = (value || "").replace(/\s/g, "");
  if (maxLength) cleaned = cleaned.slice(0, maxLength);
  return cleaned;
};

const Phone = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  innerRef,
  required,
  direction,
  maxLength,
  onChange = () => {},
  onPaste,
  ...rest
}) => {
  const commitValue = (e, value) => {
    const cleaned = stripPhoneValue(value, maxLength);
    if (cleaned !== value) {
      e = { ...e, target: { ...e.target, value: cleaned } };
    }
    onChange(e);
  };

  return (
    <div
      className={classnames(
        "input__lmf",
        { __error: touched && errors },
        direction,
      )}
    >
      <Label label={label} icon={icon} required={required} />
      <div className={`input__lmf--field`}>
        <Input
          type="tel"
          inputMode="numeric"
          className={classnames({
            "input--borderd--red": touched && errors,
            "disable--input": rest.disabled,
          })}
          placeholder={placeholder}
          ref={innerRef}
          {...rest}
          onChange={(e) => commitValue(e, e.target.value)}
          onPaste={(e) => {
            onPaste?.(e);
            e.preventDefault();
            commitValue(e, e.clipboardData?.getData("text") ?? "");
          }}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

Phone.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Phone.defaultProps = {
  label: "",
  placeholder: "",
};
export default Phone;
